export const ACCOUNT_MENU_ID = 'account-menu';
export const ACCOUNT_CARDS_MENU_ID = 'account-cards-menu';
